import { lazy } from "react";



const HospitalJobs = lazy(
  () => import("../components/pages/HospitalJobs"),
);
const CandidateMyApplication = lazy(
  () => import("../components/CandidateMyApplication/CandidateMyApplication"),
);
const ViewCandidate = lazy(
  () =>
    import("../components/CandidateRegistrationFlow/ViewCandidateDetails/ViewCandidate"),
);
const ViewJobDetails = lazy(() => import("../components/pages/ViewJobDetails"));
const Home = lazy(() => import("../components/pages/HomePage/HomePage"));
const Jobs = lazy(() => import("../components/pages/Jobs"));
const Hospitals = lazy(() => import("../components/pages/Hospitals"));
const FlowLayoutRoutes = lazy(() => import("./FlowLayoutRoutes"));
const HospitalDetails = lazy(() => import("../components/pages/HospitalDetails/HospitalDetails"));
const NurseDetails = lazy(() => import("../components/pages/NurseDetails/NurseDetails"));
const PrivacyPolicy = lazy(() => import("../components/pages/PrivacyPolicy"));
const HospitalManagement = lazy(
  () => import("../components/HospitalManagement/HospitalManagement"),
);
const CandidateRegistrationFlow = lazy(
  () =>
    import("../components/CandidateRegistrationFlow/CandidateRegistrationFlow"),
);

export const publicRoutes = [
  { path: "/", Component: Home },
  { path: "/home", Component: Home },
  { path: "/jobs", Component: Jobs },
  { path: "/hospitals", Component: Hospitals },
  { path: "/viewJobDetails/:jobId", Component: ViewJobDetails },
  { path: "/hospitalJobs/:hospitalId", Component: HospitalJobs },
  { path: "/hospitalDetails", Component: HospitalDetails },
  { path: "/nurseDetails", Component: NurseDetails },
  { path: "/privacy-policy", Component: PrivacyPolicy },

];

export const protectedRoutes = [
  { path: "/employeeFlow/*", Component: FlowLayoutRoutes },
  { path: "/hospitalManagement", Component: HospitalManagement },
  { path: "/myApplication", Component: CandidateMyApplication },
  { path: "/viewCandidate/:candidateId", Component: ViewCandidate },

  {
    path: "/candidateRegistrationJourney",
    Component: CandidateRegistrationFlow,
  },
];
